import React, { useState, useEffect, useMemo, useCallback, useReducer } from "react";
import { useDispatch, useSelector, batch } from "react-redux";
import { useParams } from "react-router-dom";

import { useUser } from "../../../../context/UserContext";
import { fetchOpportunitiesRequest } from "../../../../store/features/actions/opportunities/opportunitesActions";
import { fetchWinOpportunitiesRequest, updateWinBookmarkSuccess } from "../../../../store/features/actions/opportunities/winOpportunitiesActions";

import OpportunityFilterContainer from "./opportunityFilterContainer/OpportunityFilterContainer";
import GenericTable from "../../genericComponents/genericTableComp/GenericTable";
import TagList from "../../genericComponents/tag/TagList";
import IOSSpinner from "../../../HtmlElements/IOSSpinner";
import ScHeaderComp from "../../genericComponents/genericTableComp/genericTableScHeader/ScHeaderComp";
// import TagOverflowHandler from "../../uiUtils/TagOverflowHandler";

// import BattleCard from "./CardTabs/BattleCard";
import ContactMapCard from "./CardTabs/ContactMapCard";
import BusinessCaseCard from "./CardTabs/BusinessCaseCard";
import News from "./CardTabs/News";
import ValueSellingPrompter from "./CardTabs/ValueSellingFramework";
import NextSteps from "./CardTabs/NextSteps";

import "./SpotOpportunities.css";
import { deleteOpportunity, fetchConvertToWin, markReadByUser, toogleOppBookmark } from "../../../../services/iqApiV2";
import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";
import MemoryContainerSC from "../../../Navigation/memoryComps/MemoryContainerSC";
import ClosureCard from "./CardTabs/ClosureCard";
import { useBanner } from "../../../../context/BannerContext";
import PitchCard from "./CardTabs/PitchCard";
import TR3DotMenu from "../../genericComponents/genericTableComp/TR3DotMenu";
import SimpleSearchBar from "../../genericComponents/simpleSearchBar/SimpleSearchBar";
// import StatusIndicator from "../../genericComponents/resizeableTable/StatusIndicator";
import { useGroupTaskWebSocket } from "../../../../context/GroupTaskWebSocketContext";
import BattleCardV2 from "./CardTabs/BattleCardV2";
import { dynamicSmartSort } from "../../../TableComponents/dynamicSortFunction";
// import SpotContactBC from "../TargetedReachOut/troSubTabs/SpotContactBC";
import ChampionCard from "./CardTabs/ChampionCard";
// import ReachOutKitSCRO from "../TargetedReachOut/troSubTabs/reachOutSC/ReachOutKitSCRO";
import ResizableDivForTag from "../../uiUtils/resizeobs/ResizableDivForTag";
// import ReachOutKitSCROV1 from "../TargetedReachOut/troSubTabs/reachOutSC/ReachOutKitSCROV1";
import SimpleBookmark from "../../genericComponents/simpleBookmark/SimpleBookmark";
import { FetchSpotContactsRequest } from "../../../../store/features/actions/targetedReachout/spotContactsActions";
// import InterconnectedMarket from "./CardTabs/InterconnectedMarket";
import SpotContactBCV2 from "../TargetedReachOut/troSubTabs/SpotContactBCV2";
// import ReachOutKitSCROV2 from "../TargetedReachOut/troSubTabs/reachOutSC/ReachOutKitSCROV2";
import MoveToAutoNurture from "../../AutoNurture/SideCardsForAutoNurture/childCompsForNurtureCard/MoveToAutoNurture";
import SimpleThemedButton from "../../genericComponents/simpleTextField/SimpleThemedButton";
import ReachoutV2Wrapper from "../TargetedReachOut/troSubTabs/reachOutSC/ReachoutV2Wrapper";
import * as FeatherIcon from "react-feather";
import ReachOutKitSCROV1 from "../TargetedReachOut/troSubTabs/reachOutSC/ReachOutKitSCROV1";
import { useAuthorizedUser } from "../../../../context/AuthorizedUserContext";
import StatusIndicator from "../../genericComponents/resizeableTable/StatusIndicator";
import ReachoutV3Wrapper from "../TargetedReachOut/troSubTabs/reachOutSC/ReachoutV3Wrapper";

const iconSVG = (
  <svg xmlns="http://www.w3.org/2000/svg" className="top_tab_icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#535458" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
);


function WinOpportunities() {
  const dispatch = useDispatch();
  const [tabData, setTabData] = useState([]);
  const { clientName, accountName } = useParams();
    //  const { isAuthorized, isAuthLoading } = useAuthorizedUser();
  const { user } = useUser();
  const { opportunitesData, opportunitesLoading } = useSelector(state => state.opportunitiesReducer);
  const { winOpportunitesData, winOpportunitesLoading } = useSelector(state => state.winOpportunitiesReducer);
  const [searchQuery, setSearchQuery] = useState(""); // Search input state
  const [filters, setFilters] = useState({});
  const [filterOptions, setFilterOptions] = useState([]);
  const [activeTab, setActiveTab] = useState("battle_card_wo");
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [currRow, setCurrRow] = useState();
  const [selectedOpportunity, setSelectedOpportunity] = useState({
    id: null,
    name: null,
    desc: null,
    mainSignal: null,
    relevanceScore: null,
    oppLvlUnmetNeed: null,
    oppLvlSubsignal: null,
    mappedProducts: null,
    oppLvlBu:null
  });
  const [showMemSc,setShowMemSc]= useState(false);
  const {getDataById } = useGroupTaskWebSocket();
  const [isMounted, setIsMounted] = useState(false);
  const { spotContactsData, spotContactsLoading } = useSelector(
    (state) => state?.spotContactsReducer
  );
  

  
  const handleBookmarkToggle = async(oppId) => {
    const postCall = (resp) => {
      if (resp !== undefined) {
        dispatch(updateWinBookmarkSuccess(oppId, resp));
        {resp ? showBanner({ message: 'Bookmark Saved',title:"Alert", type: 'success', duration: 2000 }): showBanner({ message: 'Bookmark Removed',title:"Alert", type: 'info', duration: 2000 })}
      }else{
        showBanner({ message: 'Error While Bookmarking',title:"Error", type: 'error', duration: 2000 })
      }
    };
  
   await toogleOppBookmark(oppId, user?.id, postCall);
  };
  const commonProps = useMemo(() => ({
    opportunityId: selectedOpportunity.id,
    opportunityName: selectedOpportunity.name,
    opportunityDescription: selectedOpportunity.desc,
    mainSignal:selectedOpportunity.mainSignal,
    relevanceScore:selectedOpportunity.relevanceScore,
    oppLvlUnmetNeed:selectedOpportunity?.oppLvlUnmetNeed, 
    oppLvlSubsignal:selectedOpportunity?.oppLvlSubsignal,
    mappedProducts:selectedOpportunity?.mappedProducts,
    oppLvlBu:selectedOpportunity?.oppLvlBu
    
  }), [selectedOpportunity]);
  const showBanner = useBanner();
  const [showContactSc,setShowContactSc]  = useState(null);
    const handleOnContactCardClick=(data)=>{
    setShowContactSc(data)
    setActiveTab("battle_card_sc")
  }

    const handleOnBackClick=()=>{
                setShowContactSc(null)
                   setActiveTab("contact_map_wo")
                
                  if (!["battle_card_sc","champion_note_sc","reachout_sc"].includes(activeTab)) {
                    setShowMoreModal(false)
                 
                  }


  }

  


const tabConfigForContact = useMemo(() => {
  const baseTabs = [
    {
      key: "battle_card_sc",
      label: "Battle Card",
      tabId: "battle_card",
      Component: () => <SpotContactBCV2 contactId={showContactSc?.id} />,
      icon: iconSVG,
      tagIcon: <img src="/img/blueDocIcon.png" width="16" />,
    },
    ...(clientName === "MARKETS & MARKETS"
      ? [
          {
            key: "champion_note_sc",
            label: "Champion Note",
            tabId: "champion_note",
            Component: () => (
              <ChampionCard
                contact_name={showContactSc?.name}
                designation={showContactSc?.title}
              />
            ),
            icon: iconSVG,
            tagIcon: <img src="/img/blueDocIcon.png" width="16" />,
          },
        ]
      : []),
  ];

  // Conditional Reachout tab
  const reachoutTab =
   (true)
      ? {
          key: "reachout_sc",
          label: "Auto Nurture",
          tabId: "reach_out",
          dontShow:true,
          // from potential contacts
          Component: () => (
            <ReachoutV3Wrapper
              oppDetail={
                {
                  opportunityId: commonProps?.opportunityId,
                  opportunity_name: commonProps?.opportunityName,
                  mappedProducts:commonProps?.mappedProducts,
                  opportunityDescription:commonProps?.opportunityDescription
                }
              }
              // contact_name={showContactSc?.name}
              contactId={showContactSc?.id}
              contactDetail={showContactSc}
              // linkedInUrl={showContactSc?.linkedin_url}
              // contactJobTitle={showContactSc?.title}
            />
          ),
          icon: iconSVG,
          tagIcon: <img src="/img/blueDocIcon.png" width="16" />,
        }
      : {
          key: "reachout_sc",
          label: "Reach Out",
          tabId: "reach_out",
          Component: () => (
            <ReachOutKitSCROV1
              opportunity_details={[
                {
                  _id: commonProps?.opportunityId,
                  opportunity_name: commonProps?.opportunityName,
                },
              ]}
              contact_name={showContactSc?.name}
              contactId={showContactSc?.id}
              oppId={commonProps?.opportunityId}
              linkedInUrl={showContactSc?.linkedin_url}
              contactJobTitle={showContactSc?.title}
            />
          ),
          icon: iconSVG,
          tagIcon: <img src="/img/blueDocIcon.png" width="16" />,
        };

  return [...baseTabs, reachoutTab];
}, [clientName, showContactSc]);
 
const tabConfig = useMemo(() => {
  const baseTabs = [
    {
      key: "battle_card_wo",
      tabId: "battle_card",
      label: "Battle Card",
      Component: () => <BattleCardV2 {...commonProps} />,
      icon: iconSVG,
      tagIcon: <img src="/img/blueDocIcon.png" width="16" />,
    },
    {
      key: "contact_map_wo",
      tabId: "contact_map",
      label: "Potential Contacts",
      Component: () => (
        <ContactMapCard
          opportunityId={commonProps?.opportunityId}
          contact_list={spotContactsData}
          onContactCardClick={handleOnContactCardClick}
        />
      ),
      icon: iconSVG,
      tagIcon: <img src="/img/blueDocIcon.png" width="16" />,
    },
    {
      key: "business_case_wo",
      tabId: "business_case",
      label: "Business Case",
      Component: () => <BusinessCaseCard {...commonProps} />,
      icon: iconSVG,
      tagIcon: <img src="/img/blueDocIcon.png" width="16" />,
    },
    {
      key: "news_wo",
      tabId: "news",
      label: "News",
      Component: () => <News {...commonProps} />,
      icon: iconSVG,
      tagIcon: <img src="/img/redDocIcon.png" width="16" />,
    },
    {
      key: "prompter_wo",
      tabId: "value_selling_prompter",
      label: "Prompter",
      Component: () => <ValueSellingPrompter {...commonProps} />,
      icon: iconSVG,
      tagIcon: <img src="/img/redDocIcon.png" width="16" />,
    },
    {
      key: "next_step_wo",
      tabId: "next_step",
      label: "Next Step",
      Component: () => <NextSteps {...commonProps} />,
      icon: iconSVG,
      tagIcon: <img src="/img/redDocIcon.png" width="16" />,
    },
    {
      key: "pitch_card_wo",
      tabId: "generate_pitch",
      label: "Pitch",
      Component: () => <PitchCard {...commonProps} />,
      icon: iconSVG,
      tagIcon: <img src="/img/redDocIcon.png" width="16" />,
    },
  ];

  // Append conditional tabs
  if (true) {
    baseTabs.push(
      {
        key: "auto_nurutre_so",
        tabId: "auto_nurture",
        label: "Auto Nurture",
          dontShow:true,
        Component: () => (
          <MoveToAutoNurture
            currOpp={currRow}
            setShowMoreModalForAn={setShowMoreModal}
          />
        ),
        icon: iconSVG,
        tagIcon: <img src="/img/blueDocIcon.png" width="16" />,
      },
      {
        key: "closure_note_wo",
        tabId: "closure_note",
        label: "Closure Note",
        Component: () => <ClosureCard {...commonProps} />,
        icon: iconSVG,
        tagIcon: <img src="/img/redDocIcon.png" width="16" />,
      }
    );
  }

  return baseTabs;
}, [commonProps]);


   const initialSortState = {
    sortKey: "",
    sortConfig: {},
  };

  const sortReducer = (state, action) => {
    switch (action.type) {
      case "SET_SORT_KEY":
        return { ...state, sortKey: action.payload };
      case "SET_SORT_CONFIG":{
        const payload = action.payload?{order:action.payload}:{}
        return { ...state, sortConfig: payload };
      }
      default:
        return state;
    }
  };
  const [sortState, dispatchSort] = useReducer(sortReducer, initialSortState);


  const updateSortKey = (value) => {
    console.log("updateSortKey",value)
    dispatchSort({ type: "SET_SORT_KEY", payload: value });
  };

  const updateSortConfig = (value) => {
       console.log("updateSortConfig",value)
    dispatchSort({ type: "SET_SORT_CONFIG", payload: value });
  };
  

  const liveOpps = getDataById("win_opp_table")
  const handleSideCard = useCallback(
  async (e, item, tabId) => {
    console.log("win_opp_table", item);
    e.preventDefault();
    e.stopPropagation();

    setShowMoreModal(true);
    setSelectedOpportunity({
      id: item._id,
      name: item.opportunity_name,
      desc: item.opportunity_description,
      mainSignal: item.tag,
      relevanceScore: item.relevance_score,
      mappedProducts:item?.mapped_products,
      oppLvlUnmetNeed:item?.unmet_need, 
      oppLvlSubsignal:item?.sub_signal,
      oppLvlBu:item?.business_unit
    });
    setCurrRow(item);
    setActiveTab(tabId || "battle_card_wo");

    try {
      if (item?.is_read === false) {
        const resp = await markReadByUser(user?.id, item?._id);
        if (resp) {
          dispatch(fetchWinOpportunitiesRequest({
            clientName,
            accountName,
            userId: user?.id,
            type: "win"
          }));
        }
      }
    } catch (err) {
      console.error("Failed to mark as read:", err);
    }
  },
  [user, clientName, accountName, dispatch]
);


    const handleDeleteOpp = useCallback(async (e, userId, item) => {
      e.preventDefault();
      e.stopPropagation();
      const resp=  await deleteOpportunity(userId, item?._id); // Pass params if needed
      if (resp) {
        showBanner({ message: 'Deleted From Win Opportunities',title:"Alert", type: 'success', duration: 5000 })
        dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId:userId, type: "spot" }));
        dispatch(fetchWinOpportunitiesRequest({ clientName, accountName, userId: user.id, type: "win" }))
      }
    }, []);

    const getListTags = (my_data, idx) => {
    const tabConfig = my_data.map((item, i) => ({
      key: `${idx}-${i}`, // unique key
      label: (
        <>
          <FeatherIcon.Users 
            alt="users" 
            style={{ color: "#4B84E9", maxHeight: "13px" }} 
            className="" 
          />
          {item?.firstname} {item?.lastname}
        </>
      )
    }));

    return (
      <ResizableDivForTag 
        handleSideCard={() => {}} 
        items={tabConfig} 
        rowData={{}} 
      />
    );
  };

useEffect(() => {
  if (!winOpportunitesData) return;

  let filteredData = winOpportunitesData;
  console.log(filteredData,sortState.sortKey,sortState.sortConfig)

   filteredData = dynamicSmartSort(filteredData,sortState.sortKey,sortState.sortConfig);
  // Apply search filter
  if (searchQuery) {
    const query = searchQuery.toLowerCase();
    filteredData = filteredData.filter(item =>
      item.opportunity_name?.toLowerCase().includes(query) ||
      item.tag?.toLowerCase().includes(query) ||
      item.relevance_score?.toLowerCase().includes(query)
    );
  }

  // Apply filters
  filteredData = filteredData.filter(item =>
    Object.entries(filters).every(([key, values]) =>
      !values.length || values.includes(item[key.toLowerCase()] || item[key])
    )
  );

 

  // Map data with enhanced UI components
  const transformedData = filteredData.map(item => ({
    ...item,
    is_bookmarked:<SimpleBookmark key={item?._id} isFilled={item?.is_bookmarked} users={item?.inFavUsers || []} customCallback={async()=>{await handleBookmarkToggle(item?._id)}}/>,
    opportunity_name: (
      <div className="win-opp-name-detal" onClick={(e) => handleSideCard(e, item)}>
        <div className="gtr-cell-content">{item?.opportunity_name}</div>
        <div className="win-opp-name-detal-xtra">
          <div className="opp-user-icon-container">
            <img src="/img/users.png" alt="users" className="mr-1" /> {item.contact_count}
          </div>
          {/* <div className="win-opp-name-detal-xtra-divider" /> */}
        </div>
      </div>
    ),
    tag: (
      <div onClick={(e) => handleSideCard(e, item)}>
        <TagList tags={item.tag} />
      </div>
    ),
    documents: (
     <ResizableDivForTag handleSideCard={handleSideCard} items={tabConfig} rowData={item} />
      
    ),
  movedToWinByUser: (
     getListTags(item?.movedToWinByUser || [])
      
    ),
  actions: (<span style={{display:"flex",gap:"1rem"}}>

        {item?.auto_nurture_in_progress  && (item?.auto_nurture_status == "draft" || item?.auto_nurture_status == "in_queue") ?  <>
               {item?.auto_nurture_status === "draft" ? 
                <StatusIndicator
                  variant="info"
                  text="Nurture is in draft"
                  onClickComp={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleSideCard(e, item, "auto_nurutre_so")}}
                /> : <StatusIndicator
                        variant="success"
                        text="Nurture in Progress"
                        onClickComp={(e) =>
                        handleSideCard(e, item, "auto_nurutre_so")
                   }
                 />}
                </> :<SimpleThemedButton  variant="outline" buttonText={<> Auto Nurture</>} loaderTxt="Moving to Win" onBtnClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleSideCard(e,item,"auto_nurutre_so");
        }}/>}

        </span>
      ),
    saveFav: (
      <TR3DotMenu
        menuItems={[
          { label: "Delete", onMenuClick: (e) => handleDeleteOpp(e, user?.id, item) }
        ]}
      />
    )
  }));

  setTabData(transformedData);
}, [winOpportunitesData, sortState,searchQuery, filters, handleSideCard, tabConfig]);

  // console.log("liveOpps in win",liveOpps)
  



  useEffect(() => {
    if (!liveOpps?.length) return;
    let count = 0;
   
    const completedOrFailed = liveOpps.filter(
      (item) => item.status === "completed" || item.status === "failed"
    );
  
    if (completedOrFailed.length === 0) return;
  
    
    const intervalId = setInterval(() => {
      if (count >= 3) {
        clearInterval(intervalId);
        return;
      }
        dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId:user.id, type: "spot" }));
        dispatch(fetchWinOpportunitiesRequest({ clientName, accountName, userId: user.id, type: "win" }))
      count++;
    }, 10000); // Runs every 5s 
  
    return () => clearInterval(intervalId);
  }, [liveOpps?.length]);
  
  const appliedFiltersCount = useMemo(() =>
    Object.values(filters).reduce((acc, val) => acc + (val.length || 0), 0), [filters]);

 const tableColumns = useMemo(() => {
    const baseColumns = [
      { id: "is_bookmarked", label: "", width: 15, alignment: "left" },
      { id: "opportunity_name", label: "Opportunity", width: 100, alignment: "flex-start" },
      { id: "tag", label: "Signal", width: 90, alignment: "flex-start" },
      { id: "documents", label: "Opportunity Win Kit", width: true ? 150:200, alignment: "flex-start", disableColSort: true },
      { id: "movedToWinByUser", label: "Win by", width: 50, alignment: "flex-start", disableColSort: true },
      { id: "saveFav", label: "", width: 10, clickAction: true, alignment: "center", disableColSort: true },
    ];

    // conditionally add actions column if authorized
    if (true) {
      baseColumns.splice(5, 0, {
        id: "actions",
        label: "Actions",
        width: 80,
        alignment: "flex-start",
        disableColSort: true,
      });
    }

    return baseColumns;
  }, []);
  const onApply = async( ids) => {
          const resp = await fetchConvertToWin(ids, user?.id,()=>{ 
          dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId: user?.id, type: "spot" }));
          dispatch(fetchWinOpportunitiesRequest({ clientName, accountName, userId: user.id, type: "win" }));});
          if (resp) {
            setFilters({})
            showBanner({ message: 'Moved To Win Opportunities',title:"Alert", type: 'info', duration: 2000 })
          }
  };

  useEffect(() => {
    if (clientName && accountName && user?.id) {
      dispatch(fetchWinOpportunitiesRequest({ clientName, accountName, userId: user.id, type: "win" }));
      dispatch(fetchOpportunitiesRequest({ clientName, accountName, userId: user.id, type: "spot" }));
    }
  }, [clientName, accountName, user?.id]);

  useEffect(() => {
      setIsMounted(true);
      if (clientName && accountName && user?.id) {
        dispatch(
          FetchSpotContactsRequest({
            clientName,
            accountName,
            userId: user?.id,
            type: "all",
          })
        );
      }
      return () => setIsMounted(false);
  }, [clientName, accountName, user?.id, dispatch]);

  useEffect(() => {
    if (opportunitesData?.length) {
      setFilterOptions(opportunitesData);
    }
  }, [opportunitesData]);

  return (
    <>
      <OpportunityFilterContainer
        filterTxt="Select Opportunities"
        filterOptions={filterOptions}
        filters={filters}
        setFilters={setFilters}
        notSingleton={false}
        onApply={onApply}
        loading={opportunitesLoading}
        type="win"
        mainTitl="Close deals faster with your Opportunity win kit"
        filterTitl="Pick from Spot Opportunities to generate kit"
        oppBtnTitl="Or Add your existing Opportunity to generate kit"
      />

      <div className="find-opportunities-container mounted">
      <span className="find-opportunities-header-container">
        <span style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", marginBottom:'0px' }}>
          <h6 className="find-opportunities-results-title">
            Showing {winOpportunitesLoading || opportunitesLoading ? <IOSSpinner /> : tabData.length} Results
          </h6>
          {appliedFiltersCount > 0 && (
            <div className="find-opportunities-results-title-filter-badge">
              {appliedFiltersCount} filters applied
              <img src="/img/x.png" alt="clear" onClick={() => setFilters({})} />
            </div>
          )}
          
        </span>
        {/* <button
          className="memory_btn_trans"
          onClick={(e) =>{ 
                setShowMemSc((prev) => !prev)
                 dispatch(listGlobalMemRequest({userId:user?.id,memoryType:"opportunity"}))
              }} 
        >
          
          <img src="/img/plus1.png" className="memory_icon" />
          Memory
        </button> */}
         <SimpleSearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
        </span>

        <div className="find-opportunities-results-container">
          <GenericTable
          loadingRows={15}
          minWidthForDrawer={"60%"}
                      sortState={sortState}
            updateSortKey={updateSortKey}
            updateSortConfig={updateSortConfig}
            initialColumns={tableColumns}
            tabData={tabData}
            sideCardTabConfig={showContactSc?.id ? tabConfigForContact : tabConfig}
            showMoreModal={showMoreModal}
            oppName={commonProps?.opportunityName}
            // setShowMoreModal={setShowMoreModal}
            onModalClose={()=>{setShowContactSc(null); setShowMoreModal(false)}}
            loading={(winOpportunitesLoading || opportunitesLoading) && winOpportunitesData?.length==0}
            titleForSideCard={
              <ScHeaderComp 
                key={`side_card_head_comp_${commonProps?.opportunityId}`} 
                type="win_opportunities" 
                data={currRow} 
                // setShowMoreModal={setShowMoreModal} 
                opportunityId={commonProps?.opportunityId} 
                tabConfig={tabConfig} 
                showMoreModal={showMoreModal} 
                showMemComp={true} 
                memoryType={"single-opportunity"}
                activeTab={activeTab}
                   onBackClick = {handleOnBackClick}
              />
              }
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </div>
      </div>


      <GenericOverviewSideCard
        showMoreModal={showMemSc}
        setShowMoreModal={setShowMemSc}
        titleForSideCard={<div className='mem-sc-titl-cont'><img className='back-btn-img' src="/img/backArrow.png" onClick={()=>setShowMoreModal(false)}/> <span className="span_memory">Memory</span></div>}
        comp={<MemoryContainerSC memoryType="opportunity"/>}
        minWidthForDrawer="30%"
        disableXbtn
          preserveState={false}
        />
    </>
  );
}

export default WinOpportunities;